import service from "./index.js";

//获取轮播图列表
export function bannersList() {
  return service.post(`/banners`);
}
//获取关于我们信息
export function aboutUs() {
  return service.post(`/about-us`);
}

//获取核心业务板块列表
export function segments() {
  return service.post(`/business-segments`);
}
//获取荣誉资质列表
export function qualifications() {
  return service.post(`/honor-qualifications`);
}
//获取新闻列表
export function newsList(data) {
  return service.post(`/news/list`, data);
}
//获取新闻详情
export function newDetail(data) {
  return service.post(`/news/detail`, data);
}

//搜索新闻
// export function newsSearch(data) {
//     return request({
//       url: "/news/search",
//       method: "POST",
//       data,
//     });
//   }
// 
//获取联系我们信息
export function contactInfo() {
  return service.post(`/contact/info`);
}
//获取地图配置信息
export function mapConfig() {
  return service.post(`/contact/map-config`);
}
//获取产品分类列表
export function productCategories() {
  return service.post(`/product-categories`);
}
// /获取指定分类的产品列表
export function productsByCategory(data) {
  return service.post(`/products`, data);
}
// //获取产品详情
export function productDetail(data) {
  return service.post(`/product-center/product-detail`, data);
}
// //搜索产品
export function searchProducts(data) {
  return service.post(`/product-search`, data);
}
// export function productSearch(data) {
//     return request({
//       url: "/product-center/search",
//       method: "POST",
//       data,
//     });
//   }
 //获取荣誉资质列表
export function getQualifications(data) {
  return service.post(`/honor-qualifications`, data);
}
 //获取单个荣誉资质详情
 export function getQualificationDetail(data) {
  return service.post(`/honor-qualification/detail`, data);
}

 //获取人
 export function getpeople(data) {
  return service.post(`/core-experts`, data);
}